import { render } from "./EmailDeliverabilityBadge.vue?vue&type=template&id=5a5b5f20&scoped=true"
import script from "./EmailDeliverabilityBadge.vue?vue&type=script&lang=js"
export * from "./EmailDeliverabilityBadge.vue?vue&type=script&lang=js"

import "./EmailDeliverabilityBadge.vue?vue&type=style&index=0&id=5a5b5f20&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5b5f20"]])

export default __exports__